import Spinner from 'react-bootstrap/Spinner';

import CardProdutoRedutor from './CardProdutoRedutor';

import constantes from '../helpers/constanteHelper';
import Divisor from './Divisor';

import { FaFrown } from 'react-icons/fa'


function ProdutosPorClassificacaoRedutor({ produtos, resolucaoMobile, especie }) {
    let quantidadeProdutos = 0

    if (Object.keys(produtos ?? {}).length > 0) {
        Object.keys(produtos).map((classificacao) => {
            produtos[classificacao].forEach((produto) => {
                quantidadeProdutos++
            })
        });
    }

    return (
        <>
            {Object.keys(produtos ?? {}).length > 0 ? quantidadeProdutos > 0 ? Object.keys(produtos).map((classificacao, index) =>
                <>
                    {produtos[classificacao]?.length > 0 && (especie ? classificacao === especie : true) ? <>
                        <h3 className='my-5 text-center' style={{ padding: resolucaoMobile ? '0px 5px 0px 5px' : '0px', color: constantes.CORES.BRANCO_PADRAO, fontWeight: 700 }}>{classificacao.replaceAll(' - Peixes', '')}</h3>
                        <div style={{ width: '80vw', gap: '20px' }} className='mb-4 d-flex flex-wrap align-items-center justify-content-center'>
                            {produtos[classificacao].map((produto) => <CardProdutoRedutor keyCustomizada={produto['Nome do produto/serviço']} produto={produto} resolucaoMobile={resolucaoMobile} />)}
                        </div>
                        <Divisor />
                    </> : <></>}
                </>
            ) :
                <div style={{ height: '40vh', gap: '20px' }} className='mt-5 mb-5 d-flex flex-column align-items-center justify-content-center text-center'>
                    <FaFrown size={60} color='white' />
                    <span className='mt-3' style={{ fontSize: '20px', color: constantes.CORES.BRANCO_PADRAO, paddingLeft: '20px', paddingRight: '20px' }}>Nenhum produto foi encontrado com os filtros utilizados.</span>
                </div> :
                <div style={{ minHeight: '100vh', background: constantes.CORES.VERDE_RPC }} className='d-flex flex-column align-items-center'>
                    <div style={{ height: '70vh', gap: '20px' }} className='mt-5 d-flex flex-column align-items-center justify-content-center text-center'>
                        <Spinner style={{ height: '60px', width: '60px' }} variant='light' />
                        <span className='mt-3' style={{ fontSize: '20px', color: constantes.CORES.BRANCO_PADRAO, paddingLeft: '20px', paddingRight: '20px' }}>Carregando dados...<br />Por gentileza, aguarde alguns instantes.</span>
                    </div>
                </div>}
        </>
    );
}
export default ProdutosPorClassificacaoRedutor;
